import React, { FC, memo, useCallback } from "react";
import type { BottomSheetModal } from "@gorhom/bottom-sheet";
import { View, Text } from "@src/components";
import { useUnistyles } from "react-native-unistyles";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { Button } from "@src/components/Button";
import { AppBottomSheet } from "@src/features/common/components/AppBottomSheet";

type SilenceAlarmBottomSheetProps = {
  bottomSheetRef: React.RefObject<BottomSheetModal | null>;
  isAlreadySilenced?: boolean;
  onConfirm?: (minutes: number) => void;
};

const SilenceAlarmBottomSheet: FC<SilenceAlarmBottomSheetProps> = memo(
  ({ bottomSheetRef, isAlreadySilenced = false, onConfirm }) => {
    const { theme } = useUnistyles();
    const { bottom: safeAreaBottom } = useSafeAreaInsets();
    const snapPoints = ["25%"];

    const handleConfirm = useCallback(() => {
      if (onConfirm) {
        onConfirm(30);
      }
      bottomSheetRef.current?.dismiss();
    }, [bottomSheetRef, onConfirm]);

    return (
      <AppBottomSheet
        bottomSheetRef={bottomSheetRef}
        snapPoints={snapPoints}
        enableDynamicSizing={false}
        backgroundStyle={{ backgroundColor: theme.colors.background }}
      >
        <View flex={1} px="5xl" pt="lg" pb="3xl" justifyContent="center">
          <View>
            <Text textStyle="lg/medium" mb="lg">
              Silence alarm for {isAlreadySilenced ? "another " : ""}30 minutes
            </Text>
          </View>
          <View>
            <Text textStyle="sm/regular" color="textMuted">
              The camera will continue monitoring and recording activity. This will silence the strobes and sirens for
              {isAlreadySilenced ? " another" : ""} 30 minutes.
            </Text>
          </View>
        </View>
        <View flexDirection="row" px="5xl" style={{ paddingBottom: safeAreaBottom }}>
          <View flex={1}>
            <Button label="Confirm" onPress={handleConfirm} variant="primary" style={{ height: 40 }} />
          </View>
        </View>
      </AppBottomSheet>
    );
  },
);

export default SilenceAlarmBottomSheet;
